<label class="gcs">
  <span class="gcs-label">Groove neutral (dev)</span>
  <select [value]="candidate()" (change)="set($any($event.target).value)">
    <option value="none">none (current)</option>
    <option value="warm">warm</option>
    <option value="neutral">true-neutral</option>
    <option value="cool">faint-cool</option>
  </select>
  <span class="gcs-hint">Ctrl+Alt+G to hide</span>
</label>
